import Vue from "vue"
import VueRouter from "vue-router"

// 引入组件

// import loginShipper from '../page/login_shipper.vue'
// import loginAdmin from '../page/login_admin.vue'
// import loginCarr from '../page/login_carr.vue'
// import registerShipper from '../page/register_shipper.vue'
// import registerCarr from '../page/register_carr.vue'
// import login from '../page/login.vue'
import home from '../page/home.vue'
// import notFound from '../page/404.vue'
import welcome from '../page/welcome.vue'
import welcome_map from '../page/welcome_map.vue'
import welcomeY from '../page/welcomeY.vue'
import refresh from '../page/refresh.vue'
// import organizationm from '../page/systemManagement/organizationm.vue'
// import authorityCredit from '../page/systemManagement/authorityCredit.vue' //账户权限
// import dataDictionarym from '../page/basicData/dataDictionarym.vue'
// import resourcem from '../page/systemManagement/resourcem.vue'
// import rolem from '../page/systemManagement/rolem.vue'
// import driverCertify from '../page/basicData/driverCertify.vue' //司机认证信息
// import driverCertifyDetail from '../page/basicData/driverCertifyDetail.vue' //司机认证详细信息
// import driverList from '../page/basicData/driverList.vue'

// import driverNews from '../page/basicData/driverNews.vue'
// import driverNewsadd from '../page/basicData/driverNewsadd.vue'
// import collectionMoney from '../page/basicData/collectionMoney.vue'
// import collectionNews from '../page/basicData/collectionNews.vue'
// import vehiclesList from '../page/basicData/vehiclesList.vue' //车辆信息
// import DriverVehicle from '../page/basicData/DriverVehicle.vue' //司机车辆

// import vehiclesCertify from '../page/basicData/vehiclesCertify.vue' //车辆认证信息
// import vehiclesCertifyDetail from '../page/basicData/vehiclesCertifyDetail.vue' //车辆认证详细信息
// import Registration from '../page/basicData/Registration.vue' //代注册
// import carNews from '../page/basicData/carNews.vue' //车辆信息
// import carNewss from '../page/basicData/carNewss.vue' //车辆信息
// import carNewsadd from '../page/basicData/carNewsadd.vue' //车辆信息

// import orderm from '../page/businessm/orderm.vue'
// import Checkm from '../page/financialm/Checkm.vue' // 对账管理
// import Invoicem from '../page/financialm/Invoicem.vue' //发票管理
// import SettlementConfirm from '../page/financialm/SettlementConfirm.vue' //结算确认
// import SettlementSub from '../page/financialm/SettlementSub.vue' //结算确认1
// import MakeOutInvoicem from '../page/financialm/MakeOutInvoicem.vue' //开票管理

// import discountConfirm from '../page/financialm/discountConfirm.vue'   //折让确认
// import MakeOutInvoiceDetail from '../page/financialm/MakeOutInvoiceDetail.vue' //开票详情
// import ApplyMakeOutInvoice from '../page/financialm/ApplyMakeOutInvoice.vue' //申请开票
// import ViewStatement from '../page/financialm/ViewStatement.vue' //查看结算单
// import Moneym from '../page/financialm/Moneym.vue' // 资金管理
// import paymentm from '../page/businessm/paymentm.vue' // 支付管理
// import paymentDetail from '../page/businessm/paymentDetail.vue' // 支付明细
// import DirverSettlementm from '../page/financialm/DirverSettlementm.vue' // 司机结算管理
// import DirverSelDetail from '../page/financialm/DirverSelDetail.vue' // 司机结算管理详情


// import DirverSettleConfirm from '../page/financialm/DirverSettleConfirm.vue' // 司机结算管理详情
// import ElectronicScale from '../page/financialm/ElectronicScale.vue' // 司机结算管理详情
// import ShipperSettlem from '../page/financialm/ShipperSettlem.vue' // 货主结算管理
// import ShipperSettlemApply from '../page/financialm/ShipperSettlemApply.vue' //油气折让确认
// import ShipperSelDetail from '../page/financialm/ShipperSelDetail.vue' // 货主结算管理详情
// import ShipperSelUpdate from '../page/financialm/ShipperSelUpdate.vue' // 货主结算修改
// import paymentManage from '../page/financialm/paymentManage.vue' // 付款管理
// import Transferm from '../page/financialm/Transferm.vue' // 转账管理


// import Applicpayment from '../page/financialm/Applicpayment.vue'
// import collectionManagement from '../page/financialm/collectionManagement.vue'
// import credit from '../page/Contract/creditEnquiry.vue'
// import enquiryHis from '../page/Contract/enquiryHistory.vue' //授信记录
// import applicat from '../page/Contract/applicationCredit.vue' //授信申请
// import Corporateinfor from '../page/basicData/Corporateinfor.vue' //公司信息
// import CompanyInforCertified from '../page/basicData/CompanyInforCertified.vue' //公司信息已认证
// import ComInforNotCertified from '../page/basicData/ComInforNotCertified.vue' //公司信息未认证

// import companyCertify from '../page/basicData/companyCertify.vue' //公司认证信息
// import companyCertifyDetail from '../page/basicData/companyCertifyDetail.vue' //公司认证详细信息
// import subcontract from '../page/Contract/subcontract.vue' //分包合同
// import AddSubcontract from '../page/Contract/AddSubcontract.vue' //分包合同新建
// import subcontractDetail from '../page/Contract/subcontractDetail.vue' //分包合同详情
// // import carrierContract from '../page/Contract/carrierContract.vue' //承运合同
// import AddCarrierContract from '../page/Contract/AddCarrierContract.vue' //承运合同新建
// import carrierContractDetail from '../page/Contract/carrierContractDetail.vue' //承运合同详情



// import DriverContract from '../page/Contract/DriverContract.vue' //司机合同
// import DriverContractDetail from '../page/Contract/DriverContractDetail.vue' //司机合同详情

// import Goodsm from '../page/basicData/Goodsm.vue' //货物管理

// import AddressManagement from '../page/basicData/AddressManagement.vue' //地址簿
// import Waybillm from '../page/businessm/Waybillm.vue' //运单管理
// import NoWaybill from '../page/businessm/NoWaybill.vue' //未转运单
// import supplementary from '../page/businessm/supplementary.vue' //运单补录
// import supplementaryUpdate from '../page/businessm/supplementaryUpdate.vue' //运单补录修改
// import serviceEvaluation from '../page/businessm/serviceEvaluation.vue' //服务评价
// import WaybillDetails from '../page/businessm/WaybillDetails.vue' //运单管理详情
// import deliverList from '../page/businessm/deliverList.vue' //


// import CarGPSMonitoring from '../page/businessm/CarGPSMonitoring.vue' //车载GPS监控
// import WaitingTransferred from '../page/businessm/WaitingTransferred.vue' //待转运单
// import trajectory from '../page/businessm/trajectory.vue'   //单个轨迹查询
// import modifyWaybill from '../page/businessm/modifyWaybill.vue'  //修改待转运单 copyWaybill
// import copyWaybill from '../page/businessm/copyWaybill.vue'   //复制待转运单
// import trackSimulation from '../page/businessm/trackSimulation.vue' //
// import taskImpLogList from '../page/businessm/taskImpLogList.vue'
// import creategoods from '../page/businessm/creategoods.vue' //
// import SourceNew from '../page/businessm/SourceNew.vue' //
// import Companynews from '../page/basicData/Companynews.vue' //公司信息


// import Partner from '../page/basicData/Partner.vue' //经纪人管理
// import Shipper from '../page/basicData/Shipper.vue' //托运人管理
// import createOfficer from '../page/basicData/createOfficer.vue' //托运人管理
// import Carrier from '../page/basicData/Carrier.vue' //承运人人管理
// import PartnerForAdmin from '../page/basicData/PartnerForAdmin.vue' //承运人人管理
// import carTrack from '../page/businessm/carTrack.vue' //车辆轨迹管理
// import creditManage from '../page/Contract/applicationCredit.vue' //授信管理
// import fundsAccount from '../page/financialm/fundsAccount.vue' //资金账户
// import fundsAccountP1 from '../page/financialm/fundsAccountP1.vue' //资金账户-新-第一个界面
// import tuoAccount from '../page/financialm/fundsAccounTuo.vue' //资金账户--tuoyun


// import tuoAccountDetail from '../page/financialm/fundsAccounTuoDetail.vue' //资金账户--tuoyun
// import driverAccount from '../page/financialm/fundsAccounDriver.vue' //资金账户--司机
// import driverAccountDetail from '../page/financialm/fundsAccounDriverDetail.vue' //资金账户--司机
// import jingAccount from '../page/financialm/fundsAccounJing.vue' //资金账户--经济
// import jingAccountDetail from '../page/financialm/fundsAccounJingDetail.vue' //资金账户--司机
// import CapitalAccount from '../page/financialm/CapitalAccount.vue' //资金账户--托运方角色
// import CapitalAccountDetail from '../page/financialm/CapitalAccountDetail.vue' //资金账户--托运方角色
// import InvoiceDetail from '../page/financialm/InvoiceDetail.vue' //发票详情

// import driverConsumeAdd from '../page/financialm/driverConsumeAdd.vue' // 支付明细

// import invoiceConfig from '../page/interface/invoiceConfig.vue'
// import invoiceConfigDetail from '../page/interface/invoiceConfigDetail.vue'
// import zgPay from '../page/interface/zgPay.vue'
// import invoice from '../page/interface/invoice.vue'
// import zgPayBaseInfo from '../page/interface/zgPayBaseInfo.vue'
// import wsBaseInfo from '../page/interface/wsBaseInfo.vue'
// import wsBaseSettle from '../page/interface/wsBaseSettle.vue'
// import wsBaseSettleBalance from '../page/interface/wsBaseSettleBalance.vue'
// import bankCard from '../page/interface/bankCard.vue'
// import ocrDriver from '../page/interface/ocrDriver.vue'


// import ocrIdCard from '../page/interface/ocrIdCard.vue'
// import ocrVehicle from '../page/interface/ocrVehicle.vue'
// import sysCompany from '../page/systemManagement/company.vue'
// import providerManagement from '../page/systemManagement/providerManagement.vue'
// import userLog from '../page/systemManagement/userLog.vue'
// import webLog from '../page/systemManagement/webLog.vue'
// import compAccountManage from '../page/systemManagement/compAccountManage.vue'
// import paymentConfig from '../page/interface/paymentConfig.vue'


//add by liuxing@202006151544 增加"金蝶商户组"维护页面
// import jdMerchantGroup from '../page/interface/jdMerchantGroup'
// //add by liuxing@202006161034 增加"金蝶商户"维护页面
// import jdMerchantInfo from '../page/interface/jdMerchantInfo'
// //add by liuxing@202006171333 增加"金蝶-收款单"查询页面
// import arReceiveBill from '../page/interface/arReceiveBill'
// //add by liuxing@202006171541 增加echarts图表展示页
// import echartsDashboard from '../page/charts/echartsDashboard'
// //add by liuxing@202006181116 增加"金蝶-收款退款单"查询页面
// import arRefundBill from '../page/interface/arRefundBill'
// //add by liuxing@202006181416 增加"金蝶-付款单"查询页面
// import apPayBill from '../page/interface/apPayBill'
// //add by liuxing@202006181610 增加"金蝶-付款退款单"查询页面
// import apRefundBill from '../page/interface/apRefundBill'
// //add by liuxing@202006181610 增加"金蝶-应收单"查询页面
// import arReceivable from '../page/interface/arReceivable'
// //add by liuxing@202006181610 增加"金蝶-付款单"查询页面
// import apPayable from '../page/interface/apPayable'
// //add by liuxing@202006181610 增加"金蝶-客户"查询页面
// import bdCustomer from '../page/interface/bdCustomer'


// //add by liuxing@202006181610 增加"金蝶-供应商"查询页面
// import bdSupplier from '../page/interface/bdSupplier'
// //add by liuxing@202006181610 增加"金蝶-物料"查询页面
// import bdMaterial from '../page/interface/bdMaterial'
// //add by liuxing@202006181610 增加"金蝶-物料分配"查询页面
// import bdMaterialAllocate from '../page/interface/bdMaterialAllocate'
// //add by liuxing@202006181610 增加"ETC企业注册"查询页面
// import etcCompanyRegister from '../page/interface/etcCompanyRegister'
// //add by liuxing@202006181610 增加"ETC企业协议上传"查询页面
// import etcCompanyAppoint from '../page/interface/etcCompanyAppoint'
// //add by liuxing@202006181610 增加"ETC历史运单开票申请"查询页面
// import etcHisOrder from '../page/interface/etcHisOrder'
// //add by liuxing@202006181610 增加"ETC历史运单开票信息"查询页面
// import etcOrderInvoice from '../page/interface/etcOrderInvoice'
// //add by liuxing@202006181610 增加"ETC历史运单开票信息"查询页面
// import etcOrderInvoiceView from '../page/etc/etcOrderInvoiceView'


// import memberBalance from '../page/interface/memberBalance' //网商查询会员余额
// import purchasingRegister from '../page/purchase/purchasingRegister.vue'
// import WsBaseBankBind from '../page/interface/WsBaseBankBind.vue' //网商银行卡绑定
// import WsBaseBankUnbound from '../page/interface/WsBaseBankUnbound.vue' //网商银行卡解绑
// import WsUserBindList from '../page/interface/WsUserBindList.vue' //网商查询会员已绑卡列表
// import WsMemberCreation from '../page/interface/WsMemberCreation.vue' //网商会员创建
// import WsRegisteredUsers from '../page/interface/WsRegisteredUsers.vue' //网商用户注册
// import wsTransactionForm from '../page/interface/wsTransactionForm.vue' //即时交易入账表
// import singleWithdrawal from '../page/interface/singleWithdrawal.vue' //单笔提现
// import fundAllocation from '../page/interface/fundAllocation.vue' //资金调拨
// import transferToAccount from '../page/interface/transferToAccount.vue' //转账入账
// import subAccountRemitre from '../page/interface/subAccountRemitre.vue' //子账号汇入结果
// import exceptionHandling from '../page/interface/exceptionHandling.vue' //金蝶异常处理
// import WbankExceptionHandling from '../page/interface/WbankExceptionHandling.vue' //网商异常处理
// import chat from '../page/chat/index.vue'


// import compRate from '../page/taskRate/compRate.vue' //评价管理-企业评价
// import insuranceClaims from '../page/taskRate/insuranceClaims.vue' //保险理赔
// import driverRate from '../page/taskRate/driverRate.vue' //评价管理-企业评价
// import complaintAdvice from '../page/taskRate/complaintAdvice.vue' //评价管理-投诉建议
// import zgPayment from '../page/financialm/zgPayment.vue' //中钢转账登记
// import fundReconReport from '../page/financialm/fundReconReport.vue' //
// import fundReconPlatformReport from '../page/financialm/fundReconPlatformReport.vue'
// import capitalReport from '../page/financialm/capitalReport.vue'
// import withdrawalLoanStatistics from '../page/financialm/withdrawalLoanStatistics.vue' //提现借款统计


// import bregexList from '../page/batchb/regex.vue' //基础数据正则表达式
// import bzipList from '../page/batchb/batchzip.vue' //批量上传
// import bhandList from '../page/batchb/batchhand.vue' //单笔手工处理
// import bqueryList from '../page/batchb/querylist.vue' //文件查询
// import bzipfile from '../page/batchb/batchfile.vue' //压缩包明细


// import riskControlReport from '../page/financialm/riskControlReport.vue' //风控报表
// import riskControlSettlePayReport from '../page/financialm/riskControlSettlePayReport.vue' //风控报表
// import riskControlAccountReport from '../page/financialm/riskControlAccountReport.vue' //风控报表
// import SupplierContract from '../page/basicData/SupplierContract.vue' //供应商合同信息
// import dataImp from '../page/imp/imp.vue'//数据导入

// import driverPaymentReport from '../page/financialm/driverPaymentReport.vue' //司机支付流水报表
// import bizPaymentReport from '../page/financialm/bizPaymentReport.vue' //业务支付明细统计表

// import sourceQRCode from '../page/basicData/sourceQRCode.vue' //企业货源二维码

// import lossTemplate from '../page/billingRules/lossTemplate.vue' //亏吨模板


// import electricFence from '../page/basicData/electricFence.vue' //电子围栏维护
// import electricFenceMap from '../page/basicData/electricFenceMap.vue' //新增电子围栏维护

import gpsEquipment from '../page/basicData/gpsEquipment.vue' //gps设备管理

import geoGraphic from '../page/businessm/geoGraphic.vue' //省市区map
import version from "../page/version.vue"

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {

    return originalPush.call(this, location)

}

const routes = [{
        path: "/",
        redirect: '/login',
        hidden: true,
    },
    {
        path: '/login',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/login'], resolve),
    },
    {
        path: '/login_test',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/login_test'], resolve),
    },
    {
        path: '/test',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/welcome/test'], resolve),
    },
    {
        path: '/login_shipper',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/login_shipper'], resolve),
    },
    {
        path: '/login_admin',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/login_admin'], resolve),
    },
    {
        path: '/login_carr',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/login_carr'], resolve),
    },
    {
        path: '/refresh',
        name: '',
        component: (resolve) => require(['../page/refresh'], resolve),
        hidden: true,
    },
    {
        path: '/register_carr',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/register_carr'], resolve),
    }, {
        path: '/register_shipper',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/register_shipper'], resolve),
    },
    {
        path: '/404',
        name: '',
        hidden: true,
        component: (resolve) => require(['../page/404'], resolve),
    },
    {
        path: '/home',
        component: home,
        redirect: '/welcome',
        hidden: true,
        children: [{
            path: '/welcome',
            name: '驾驶舱',
            component: welcome,
            hidden: true,
            meta: { keepAlive: true ,name: "welcome"}
        }, ]
    },
    {
        path: '/home',
        component: home,
        redirect: '/welcome_map',
        hidden: true,
        children: [{
            path: '/welcome_map',
            name: '驾驶舱趋势图',
            component: welcome_map,
            hidden: true,
        }, ]
    },
    {
        path: '/home',
        component: home,
        redirect: '/welcome',
        hidden: true,
        children: [{
            path: '/version',
            name: '版本管理',
            component:  version,
            hidden: true,
        }, ]
    },
    {
        path: '',
        component: home,
        name: '系统管理',
        iconCls: 'el-icon-message', //图标样式class
        children: [{
                path: '/systemManagement/organizationm',
                name: '组织机构管理',
                component: (resolve) => require(['../page/systemManagement/organizationm'], resolve),
            },
            {
                path: '/systemManagement/resourcem',
                name: '资源管理',
                component: (resolve) => require(['../page/systemManagement/resourcem'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/systemManagement/rolem',
                name: '角色管理',
                component: (resolve) => require(['../page/systemManagement/rolem'], resolve),
            },
            {
                path: '/systemManagement/company',
                name: '公司管理',
                component: (resolve) => require(['../page/systemManagement/company'], resolve),
            },
            {
                path: '/systemManagement/authorityCredit',
                name: '权限授信',
                component: (resolve) => require(['../page/systemManagement/authorityCredit'], resolve),
            },
            {
                path: '/systemManagement/providerManagement',
                name: '服务商管理',
                component: (resolve) => require(['../page/systemManagement/providerManagement'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/systemManagement/passwordManage',
                name: '密码管理',
                component: (resolve) => require(['../page/systemManagement/passwordManage'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/purchase/purchasingRegister',
                name: '采购登记',
                component: (resolve) => require(['../page/purchase/purchasingRegister'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/service/chat',
                name: '咨询',
                component: (resolve) => require(['../page/chat/index'], resolve),
            },
            {
                path: '/systemManagement/userLog',
                name: '用户日志',
                component: (resolve) => require(['../page/systemManagement/userLog'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/systemManagement/webLog',
                name: '页面日志',
                component: (resolve) => require(['../page/systemManagement/webLog'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/systemManagement/compAccountManage',
                name: '平台账户',
                component: (resolve) => require(['../page/systemManagement/compAccountManage'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/systemManagement/sendMessage',
                name: '系统通知',
                component: (resolve) => require(['../page/systemManagement/sendMessage'], resolve),
                meta: { keepAlive: false }
            },
            {
                path: '/data-imp',
                name: '数据导入',
                component: (resolve) => require(['../page/imp/imp.vue'], resolve),
            },
            {
                path: '/settleImpConfig',
                name: '货主结算更改配置',
                component: (resolve) => require(['../page/financialm/SettleImpConfig.vue'], resolve),
            },
            {
                path: '/systemManagement/versionManage',
                name: '版本管理',
                component: (resolve) => require(['../page/systemManagement/versionManage.vue'], resolve),
                meta: { keepAlive: false, name: 'versionManage' }
            }
        ]
    },
    {
        path: '',
        component: home,
        name: '接口管理',
        iconCls: 'el-icon-message', //图标样式class
        children: [{
                path: '/interface/invoiceConfig',
                name: '开票配置',
                component: (resolve) => require(['../page/interface/invoiceConfig'], resolve),
            },
            {
                path: '/interface/invoiceConfigDetail',
                name: '开票详情',
                component: (resolve) => require(['../page/interface/invoiceConfigDetail'], resolve),
            },
            {
                path: '/interface/zgPay',
                name: '中钢支付接口',
                component: (resolve) => require(['../page/interface/zgPay'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/zgPayBaseInfo',
                name: '中钢支付配置',
                component: (resolve) => require(['../page/interface/zgPayBaseInfo'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/wsBaseInfo',
                name: '商户信息',
                component: (resolve) => require(['../page/interface/wsBaseInfo'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/wsBaseSettle',
                name: '结算户信息',
                component: (resolve) => require(['../page/interface/wsBaseSettle'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/wsBaseSettleBalance',
                name: '结算户余额',
                component: (resolve) => require(['../page/interface/wsBaseSettleBalance'], resolve),
            },
            {
                path: '/interface/invoice',
                name: '开票接口',
                component: (resolve) => require(['../page/interface/invoice'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/WsBaseBankBind',
                name: '银行卡绑定',
                component: (resolve) => require(['../page/interface/WsBaseBankBind'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/memberBalance',
                name: '网商查询会员余额',
                component: (resolve) => require(['../page/interface/memberBalance'], resolve),
            },
            {
                path: '/interface/WsBaseBankUnbound',
                name: '银行卡解绑',
                component: (resolve) => require(['../page/interface/WsBaseBankUnbound'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/WsUserBindList',
                name: '查询会员已绑卡列表',
                component: (resolve) => require(['../page/interface/WsUserBindList'], resolve),
            },
            {
                path: '/interface/WsMemberCreation',
                name: '网商会员创建',
                component: (resolve) => require(['../page/interface/WsMemberCreation'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/WsRegisteredUsers',
                name: '网商用户注册',
                component: (resolve) => require(['../page/interface/WsRegisteredUsers'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/wsTransactionForm',
                name: '即时交易入账表',
                component: (resolve) => require(['../page/interface/wsTransactionForm'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/singleWithdrawal',
                name: '单笔提现',
                component: (resolve) => require(['../page/interface/singleWithdrawal'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/fundAllocation',
                name: '资金调拨',
                component: (resolve) => require(['../page/interface/fundAllocation'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/transferToAccount',
                name: '转账入账',
                component: (resolve) => require(['../page/interface/transferToAccount'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/subAccountRemitre',
                name: '子账号汇入结果',
                component: (resolve) => require(['../page/interface/subAccountRemitre'], resolve),
                meta: { keepAlive: true }
            },

            {
                path: '/interface/bankCard',
                name: '银行卡校验',
                component: (resolve) => require(['../page/interface/bankCard'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/ocrIdCard',
                name: 'OCR-身份证',
                component: (resolve) => require(['../page/interface/ocrIdCard'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/ocrDriver',
                name: 'OCR-驾驶证',
                component: (resolve) => require(['../page/interface/ocrDriver'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/ocrVehicle',
                name: 'OCR-行驶证',
                component: (resolve) => require(['../page/interface/ocrVehicle'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/jdMerchantGroup',
                name: '金蝶商户组',
                component: (resolve) => require(['../page/interface/jdMerchantGroup'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/jdMerchantInfo',
                name: '金蝶商户',
                component: (resolve) => require(['../page/interface/jdMerchantInfo'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/arReceiveBill',
                name: '金蝶收款单',
                component: (resolve) => require(['../page/interface/arReceiveBill'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/arRefundBill',
                name: '金蝶退款单',
                component: (resolve) => require(['../page/interface/arRefundBill'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/apPayBill',
                name: '金蝶付款单',
                component: (resolve) => require(['../page/interface/apPayBill'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/apRefundBill',
                name: '金蝶付款退款单',
                component: (resolve) => require(['../page/interface/apRefundBill'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/arReceivable',
                name: '金蝶应收单',
                component: (resolve) => require(['../page/interface/arReceivable'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/apPayable',
                name: '金蝶应付单',
                component: (resolve) => require(['../page/interface/apPayable'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/interface/paymentConfig',
                name: '金蝶收付配置',
                component: (resolve) => require(['../page/interface/paymentConfig'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/bdCustomer',
                name: '金蝶客户',
                component: (resolve) => require(['../page/interface/bdCustomer'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/bdSupplier',
                name: '金蝶供应商',
                component: (resolve) => require(['../page/interface/bdSupplier'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/bdMaterial',
                name: '金蝶物料',
                component: (resolve) => require(['../page/interface/bdMaterial'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/bdMaterialAllocate',
                name: '金蝶物料分配',
                component: (resolve) => require(['../page/interface/bdMaterialAllocate'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/etcCompanyRegister',
                name: 'ETC企业注册',
                component: (resolve) => require(['../page/interface/etcCompanyRegister'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/etcCompanyAppoint',
                name: 'ETC企业协议上传',
                component: (resolve) => require(['../page/interface/etcCompanyAppoint'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/etcHisOrder',
                name: 'ETC历史运单开票申请',
                component: (resolve) => require(['../page/interface/etcHisOrder'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/etcOrderInvoice',
                name: 'ETC历史运单开票信息',
                component: resolve => require(['../page/interface/etcOrderInvoice'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/exceptionHandling',
                name: '金蝶异常处理',
                component: resolve => require(['../page/interface/exceptionHandling'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/interface/WbankExceptionHandling',
                name: '网商/中钢异常处理',
                component: resolve => require(['../page/interface/WbankExceptionHandling'], resolve),
                meta: { keepAlive: true }
            }

        ]
    },
    {
        path: '',
        component: home,
        name: '规则配置',
        iconCls: 'el-icon-message',
        children: [{
            path: '/billingRules/lossTemplate',
            name: '亏吨模板',
            component: resolve => require(['../page/billingRules/lossTemplate'], resolve),
            meta: { keepAlive: true }
        },{
            path: '/billingRules/WaybillRiskControl',
            name: '运单风控配置',
            component: resolve => require(['../page/billingRules/WaybillRiskControl'], resolve),
            meta: { keepAlive: true, name: '/billingRules/WaybillRiskControl' }
        },{
            path: '/billingRules/areaManagement',
            name: '区域管理',
            component: resolve => require(['../page/billingRules/areaManagement'], resolve),
            meta: { keepAlive: true, name: '/billingRules/areaManagement' }
        },
        {
            path: '/billingRules/bidConfiguration',
            name: '竞价配置',
            component: resolve => require(['../page/billingRules/bidConfiguration'], resolve),
            meta: { keepAlive: true, name: '/billingRules/bidConfiguration' }
        },

    ]
    },
    {
        path: '',
        component: home,
        name: '基础数据',
        iconCls: 'el-icon-message',
        children: [
            {
                path: '/welcomeY',
                name: '欢迎页',
                hidden: true,
                component: (resolve) => require(['../page/welcomeY'], resolve),
            },
            {
                path: '/basicData/sourceQRCode',
                name: '企业货源二维码',
                component: resolve => require(['../page/basicData/sourceQRCode'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/basicData/driverList',
                name: '司机管理',
                component: resolve => require(['../page/basicData/driverList'], resolve),
                meta: { keepAlive: false, name: '/basicData/driverList' }
            },
            {
                path: '/basicData/electricFence',
                name: '电子围栏维护',
                component: resolve => require(['../page/basicData/electricFence'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/basicData/electricFenceMap',
                name: '电子围栏维护新增',
                component: resolve => require(['../page/basicData/electricFenceMap'], resolve),
            },
            {
                path: '/basicData/electricFenceDetail',
                name: '电子围栏维护详情',
                component: resolve => require(['../page/basicData/electricFenceDetail'], resolve),
            },
            {
                path: '/basicData/gpsEquipment',
                name: 'GPS设备管理',
                component: gpsEquipment,
                meta: { keepAlive: true }
                // component: resolve => require(['../page/basicData/gpsEquipment'], resolve),
            },

            {
                path: '/basicData/driverNews',
                name: '司机管理1',
                component: resolve => require(['../page/basicData/driverNews'], resolve),
            }, {
                path: '/basicData/DriverVehicle',
                name: '司机车辆',
                component: resolve => require(['../page/basicData/DriverVehicle'], resolve),
            }, {
                path: '/basicData/driverCertify',
                name: '司机认证',
                component: (resolve) => require(['../page/basicData/driverCertify'], resolve),
                meta: { keepAlive: true, name: '/basicData/driverCertify' }
            }, {
                path: '/basicData/driverCertifyDetail',
                name: '司机认证信息详情',
                component: (resolve) => require(['../page/basicData/driverCertifyDetail'], resolve),
                meta: { keepAlive: true, name: '/basicData/driverCertifyDetail' }
            }, {
                path: '/basicData/driverNewsadd',
                name: '司机管理2',
                component: (resolve) => require(['../page/basicData/driverNewsadd'], resolve),
            }, {
                path: '/basicData/vehiclesList',
                name: '车辆管理',
                component: (resolve) => require(['../page/basicData/vehiclesList'], resolve),
                meta: { keepAlive: true, name: '/basicData/vehiclesList' }
            }, {
                path: '/basicData/vehiclesCertify',
                name: '车辆认证',
                component: (resolve) => require(['../page/basicData/vehiclesCertify'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/basicData/vehiclesCertifyDetail',
                name: '车辆认证信息详情',
                component: (resolve) => require(['../page/basicData/vehiclesCertifyDetail'], resolve),
                meta: { keepAlive: true, name: '/basicData/vehiclesCertifyDetail'}
            }, {
                path: '/basicData/carNews',
                name: '车辆管理1',
                component: (resolve) => require(['../page/basicData/carNews'], resolve),
            }, {
                path: '/basicData/carNewss',
                name: '车辆管理3',
                component: (resolve) => require(['../page/basicData/carNewss'], resolve),
            }, {
                path: '/basicData/carNewsadd',
                name: '车辆管理2',
                component: (resolve) => require(['../page/basicData/carNewsadd'], resolve),
            },
            {
                path: '/basicData/dataDictionarym',
                name: '数据字典管理',
                component: (resolve) => require(['../page/basicData/dataDictionarym'], resolve),
            },
            {
                path: '/basicData/companyCertify',
                name: '公司认证信息',
                component: (resolve) => require(['../page/basicData/companyCertify'], resolve),
                meta: { keepAlive: true, name: '/basicData/companyCertify'}
            },
            {
                path: '/basicData/companyCertifyDetail',
                name: '公司认证详细信息',
                component: (resolve) => require(['../page/basicData/companyCertifyDetail'], resolve),
                // meta: { keepAlive: true, name: '/basicData/companyCertifyDetail'}// 需要缓存
            },

            {
                path: '/basicData/Corporateinfor',
                name: '公司管理',
                component: (resolve) => require(['../page/basicData/Corporateinfor'], resolve),
            },
            {
                path: '/basicData/CompanyInforCertified',
                name: '公司管理1',
                component: (resolve) => require(['../page/basicData/CompanyInforCertified'], resolve),
            },
            {
                path: '/basicData/ComInforNotCertified',
                name: '公司管理2',
                component: (resolve) => require(['../page/basicData/ComInforNotCertified'], resolve),
            },
            {
                path: '/basicData/collectionMoney',
                name: '付款人管理',
                component: (resolve) => require(['../page/basicData/collectionMoney'], resolve),
                meta: { keepAlive: true, name: '/basicData/collectionMoney' }
            }, {
                path: '/basicData/collectionNews',
                name: '付款人修改',
                component: (resolve) => require(['../page/basicData/collectionNews'], resolve),
            },
            {
                path: '/basicData/Goodsm',
                name: '货物管理',
                component: (resolve) => require(['../page/basicData/Goodsm'], resolve),
                meta: { keepAlive: true, name: '/basicData/Goodsm' }
            }, {
                path: '/basicData/AddressManagement',
                name: '地址簿',
                component: (resolve) => require(['../page/basicData/AddressManagement'], resolve),
                meta: { keepAlive: true, name: '/basicData/AddressManagement' }
            },
            {
                path: '/basicData/AreaManagement',
                name: '区域管理',
                component: (resolve) => require(['../page/basicData/AreaManagement'], resolve),
                meta: { keepAlive: true, name: '/basicData/AreaManagement' }
            },
             {
                path: '/basicData/Companynews',
                name: '企业信息',
                component: (resolve) => require(['../page/basicData/Companynews'], resolve),
            }, {
                path: '/basicData/Partner',
                name: '经纪伙伴',
                component: (resolve) => require(['../page/basicData/Partner'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/basicData/Shipper',
                name: '托运伙伴',
                component: (resolve) => require(['../page/basicData/Shipper'], resolve),
            },
            {
                path: '/basicData/Registration',
                name: '代注册',
                component: (resolve) => require(['../page/basicData/Registration'], resolve),
            }, {
                path: '/basicData/createOfficer',
                name: '托运伙伴1',
                component: (resolve) => require(['../page/basicData/createOfficer'], resolve),
            }, {
                path: '/basicData/Carrier',
                name: '承运伙伴',
                component: (resolve) => require(['../page/basicData/Carrier'], resolve),
            }, {
                path: '/basicData/PartnerForAdmin',
                name: '承运伙伴1',
                component: (resolve) => require(['../page/basicData/PartnerForAdmin'], resolve),
                meta: { keepAlive: true }
            }, {
                path: '/basicData/SupplierContract',
                name: '供应商合同',
                component: (resolve) => require(['../page/basicData/SupplierContract'], resolve),
                meta: { keepAlive: true }
            },{
                path: '/basicData/VirtualGroupPartners',
                name: '虚拟集团伙伴',
                component: (resolve) => require(['../page/basicData/VirtualGroupPartners'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/basicData/AreaManagement',
                name: '区域管理',
                component: (resolve) => require(['../page/basicData/AreaManagement'], resolve),
                meta: { keepAlive: true }
            }
        ]
    },
    {
        path: '',
        component: home,
        name: '业务管理',
        iconCls: 'el-icon-message',
        children: [{
                path: '/businessm/Waybillm',
                name: '运单管理',
                component: (resolve) => require(['../page/businessm/Waybillm'], resolve),
                meta: { keepAlive: true, name: '/businessm/Waybillm' },
            },
            {
                path: '/businessm/trackQueryRecord',
                name: '轨迹查询记录',
                component: (resolve) => require(['../page/businessm/trackQueryRecord'], resolve),
                meta: { keepAlive: true, name: '/businessm/trackQueryRecord' },
            },

            {
                path: '/businessm/NoWaybill',
                name: '未转运单',
                component: (resolve) => require(['../page/businessm/NoWaybill'], resolve),
            },
            {
                path: '/businessm/supplementary',
                name: '运单补录',
                component: (resolve) => require(['../page/businessm/supplementary'], resolve),
                meta: { keepAlive: true, name: '/businessm/supplementary' } // 需要缓存
            },
            {
                path: '/businessm/supplementaryUpdate',
                name: '运单补录修改',
                component: (resolve) => require(['../page/businessm/supplementaryUpdate'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/businessm/serviceEvaluation',
                name: '服务评价',
                component: (resolve) => require(['../page/businessm/serviceEvaluation'], resolve),
            },
            {
                path: '/businessm/geoGraphic',
                name: '省市区地理围栏',
                component: geoGraphic,
                // component: (resolve) => require(['../page/businessm/geoGraphic'], resolve),
            },
            {
                path: '/businessm/WaybillDetails',
                name: '运单管理1',
                component: (resolve) => require(['../page/businessm/WaybillDetails'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            }, {
                path: '/businessm/deliverList',
                name: '发货管理',
                component: (resolve) => require(['../page/businessm/deliverList'], resolve),
                meta: { keepAlive: true, name: '/businessm/deliverList' }
            },
            {
                path: '/businessm/quotationRecord',
                name: '报价记录',
                component: (resolve) => require(['../page/businessm/quotationRecord'], resolve),
                meta: { keepAlive: true, name: '/businessm/quotationRecord' }
            },
            {
                path: '/businessm/marginManagement',
                name: '保证金管理',
                component: (resolve) => require(['../page/businessm/marginManagement'], resolve),
                meta: { keepAlive: true, name: '/businessm/marginManagement' }
            },
            {
                path: '/businessm/marginManagementDetails',
                name: '保证金管理详情',
                component: (resolve) => require(['../page/businessm/marginManagementDetails'], resolve),
                meta: { keepAlive: true, name: '/businessm/marginManagementDetails' }
            },
            

             {
                path: '/businessm/AbnormalEvent',
                name: '异常事件',
                component: (resolve) => require(['../page/businessm/AbnormalEvent'], resolve),
                meta: { keepAlive: true, name: '/businessm/AbnormalEvent' }
            },
            {
                path: '/businessm/RealTimePosition',
                name: '实时定位',
                component: (resolve) => require(['../page/businessm/RealTimePosition'], resolve),
                meta: { keepAlive: true, name: '/businessm/RealTimePosition' }
            }, {
                path: '/businessm/TrackQuery',
                name: '轨迹查询',
                component: (resolve) => require(['../page/businessm/TrackQuery'], resolve),
                meta: { keepAlive: true, name: '/businessm/TrackQuery' }
            },{
                path: '/businessm/FullMonitoring',
                name: '全图监控',
                component: (resolve) => require(['../page/businessm/FullMonitoring'], resolve),
                meta: { keepAlive: true, name: '/businessm/FullMonitoring' }
            },

            
            {
                path: '/businessm/CarGPSMonitoring',
                name: '车载GPS监控',
                component: (resolve) => require(['../page/businessm/CarGPSMonitoring'], resolve),
            },
            {
                path: '/businessm/modifyWaybill',
                name: '修改待转运单',
                component: (resolve) => require(['../page/businessm/modifyWaybill'], resolve),
            },
            {
                path: '/businessm/trajectory',
                name: '单个轨迹查询',
                component: (resolve) => require(['../page/businessm/trajectory'], resolve),
            },
            {
                path: '/businessm/copyWaybill',
                name: '复制待转运单',
                component: (resolve) => require(['../page/businessm/copyWaybill'], resolve),
            },
            {
                path: '/businessm/WaitingTransferred',
                name: '待转运单',
                component: (resolve) => require(['../page/businessm/WaitingTransferred'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/businessm/trackSimulation',
                name: 'simulator',
                component: (resolve) => require(['../page/businessm/trackSimulation'], resolve),
            },
            {
                path: '/businessm/taskImpLogList',
                name: '运单导入',
                component: (resolve) => require(['../page/businessm/taskImpLogList'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/businessm/creategoods',
                name: '发货修改',
                component: (resolve) => require(['../page/businessm/creategoods'], resolve),
                meta: { keepAlive: true, name: '/businessm/creategoods' }
                //meta: { keepAlive: false}// 不需要缓存
            }, {
                path: '/businessm/SourceNew',
                name: '发货修改1',
                component: (resolve) => require(['../page/businessm/SourceNew'], resolve),
                meta: { keepAlive: true, name: '/businessm/SourceNew'}
            },{
                path: '/businessm/dialog/transportAgreement',
                name: '发货合同',
                component: (resolve) => require(['../page/businessm/dialog/transportAgreement'], resolve),
                // meta: { keepAlive: true, name: '/businessm/dialog/transportAgreement'}
            }, {
                path: '/businessm/carTrack',
                name: '车辆轨迹查询',
                component: (resolve) => require(['../page/businessm/carTrack'], resolve),
            },
            {
                path: '/businessm/paymentm',
                name: '司机支付',
                component: (resolve) => require(['../page/businessm/paymentm'], resolve),
                meta: { keepAlive: true, name: '/businessm/paymentm' },

            },
            {
                path: '/businessm/paymentmTwo',
                name: '司机支付网商2.0',
                component: (resolve) => require(['../page/businessm/paymentmTwo'], resolve),
                meta: { keepAlive: true, name: '/businessm/paymentmTwo' },
            },
             {
                path: '/businessm/paymentDetail',
                name: '支付明细',
                component: (resolve) => require(['../page/businessm/paymentDetail'], resolve),
            },
            {
                path: '/batchb/regex',
                name: '基础数据管理',
                component: (resolve) => require(['../page/batchb/regex'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/batchb/batchzip',
                name: '批量管理',
                component: (resolve) => require(['../page/batchb/batchzip'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/batchb/batchhand',
                name: '手工管理',
                component: (resolve) => require(['../page/batchb/batchhand'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/batchb/batchquery',
                name: '回单查询',
                component: (resolve) => require(['../page/batchb/querylist'], resolve),
                meta: { keepAlive: true },
            },
            {
                path: '/batchb/batchfile',
                name: '压缩包明细',
                component: (resolve) => require(['../page/batchb/batchfile'], resolve),
            }, {
                path: '/etc/etcOrderInvoiceView',
                name: 'ETC开票',
                component: (resolve) => require(['../page/etc/etcOrderInvoiceView'], resolve),
                meta: { keepAlive: true }
            }
        ]
    },
    {
        path: '',
        component: home,
        name: '财务管理',
        iconCls: 'el-icon-message',
        children: [
            // {
            //   path: '/financialm/Checkm',
            //   component: c,
            //   name: '对账管理'
            // },
            // {
            //   path: '/financialm/monthlyStatement',
            //   name: '月度对账单',
            //   component: (resolve) => require(['../page/financialm/monthlyStatement'], resolve),
            // },
            {
                path: '/financialm/Invoicem',
                name: '发票管理',
                component: (resolve) => require(['../page/financialm/Invoicem'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/SettlementConfirm',
                name: '结算确认',
                component: (resolve) => require(['../page/financialm/SettlementConfirm'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/SettlementSub',
                name: '结算开票信息',
                component: (resolve) => require(['../page/financialm/SettlementSub'], resolve),
            },
            {
                path: '/financialm/MakeOutInvoicem',
                name: '开票管理',
                component: (resolve) => require(['../page/financialm/MakeOutInvoicem'], resolve),
                meta: { keepAlive: true, name: '/financialm/MakeOutInvoicem' }
            },
            {
                path: '/financialm/ApplyMakeOutInvoice',
                name: '申请开票',
                component: (resolve) => require(['../page/financialm/ApplyMakeOutInvoice'], resolve),
                meta: { keepAlive: true } // 不需要缓存
            },
            {
                path: '/financialm/MakeOutInvoiceDetail',
                name: '批次号详情',
                component: (resolve) => require(['../page/financialm/MakeOutInvoiceDetail'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/ViewStatement',
                name: '查看结算单',
                component: (resolve) => require(['../page/financialm/ViewStatement'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/Moneym',
                name: '资金管理',
                component: (resolve) => require(['../page/financialm/Moneym'], resolve),
            },
            {
                path: '/financialm/Transferm',
                name: '转账管理',
                component: (resolve) => require(['../page/financialm/Transferm'], resolve),
            },
            {
                path: '/financialm/DirverSettlementm',
                name: '司机结算',
                component: (resolve) => require(['../page/financialm/DirverSettlementm'], resolve),
                meta: { keepAlive: true, name: '/financialm/DirverSettlementm' }
            },
            {
                path: '/financialm/DirverSelDetail',
                name: '司机结算详情',
                component: (resolve) => require(['../page/financialm/DirverSelDetail'], resolve),
                // meta: { keepAlive: false }// 不需要缓存
            },
            {
                path: '/financialm/DirverSettleConfirm',
                name: '司机结算2',
                component: (resolve) => require(['../page/financialm/DirverSettleConfirm'], resolve),
                // meta: { keepAlive: false }// 不需要缓存
            },
            {
                path: '/financialm/ElectronicScale',
                name: '电子磅单',
                component: (resolve) => require(['../page/financialm/ElectronicScale'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/ShipperSettlem',
                name: '货主结算',
                component: (resolve) => require(['../page/financialm/ShipperSettlem'], resolve),
                meta: { keepAlive: true, name: '/financialm/ShipperSettlem' }
            },
            {
                path: '/financialm/ShipperSettlemApply',
                name: '油气折让确认',
                component: (resolve) => require(['../page/financialm/ShipperSettlemApply'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/ShipperSelDetail',
                name: '货主结算1',
                component: (resolve) => require(['../page/financialm/ShipperSelDetail'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/ShipperSelUpdate',
                name: '货主结算2',
                component: (resolve) => require(['../page/financialm/ShipperSelUpdate'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/paymentManage',
                name: '付款管理',
                component: (resolve) => require(['../page/financialm/paymentManage'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/Applicpayment',
                name: '付款申请',
                component: (resolve) => require(['../page/financialm/Applicpayment'], resolve),
            },
            {
                path: '/financialm/collectionManagement',
                name: '收款管理',
                component: (resolve) => require(['../page/financialm/collectionManagement'], resolve),
                meta: { keepAlive: true }
            },

            {
                path: '/financialm/fundsAccount',
                name: '承运资金账户',
                component: (resolve) => require(['../page/financialm/fundsAccount'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/fundsAccounTuo',
                name: '托运人-资金信息',
                component: (resolve) => require(['../page/financialm/fundsAccounTuo'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/fundsAccounTuoDetail',
                name: '托运人-资金账户明细',
                component: (resolve) => require(['../page/financialm/fundsAccounTuoDetail'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/fundsAccountP1',
                name: '承运商-资金账户',
                component: (resolve) => require(['../page/financialm/fundsAccountP1'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/fundsAccounDriver',
                name: '司机-资金账户',
                component: (resolve) => require(['../page/financialm/fundsAccounDriver'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/fundsAccounDriverDetail',
                name: '司机-资金账户明细',
                component: (resolve) => require(['../page/financialm/fundsAccounDriverDetail'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/fundsAccounJing',
                name: '经纪人-资金账户',
                component: (resolve) => require(['../page/financialm/fundsAccounJing'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/fundsAccounJingDetail',
                name: '经纪人-资金账户明细',
                component: (resolve) => require(['../page/financialm/fundsAccounJingDetail'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/financialm/CapitalAccount',
                name: '资金账户',
                component: (resolve) => require(['../page/financialm/CapitalAccount'], resolve),
            },
            {
                path: '/financialm/CapitalAccountDetail',
                name: '资金账户1',
                component: (resolve) => require(['../page/financialm/CapitalAccountDetail'], resolve),
            },
            {
                path: '/financialm/driverConsumeAdd',
                name: '司机消费事件',
                component: (resolve) => require(['../page/financialm/driverConsumeAdd'], resolve),
            },
            {
                path: '/financialm/InvoiceDetail',
                name: '发票详情',
                component: (resolve) => require(['../page/financialm/InvoiceDetail'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/zgPayment',
                name: '中钢转账登记',
                component: (resolve) => require(['../page/financialm/zgPayment'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/fundReconReport',
                name: '资金收支汇总表',
                component: (resolve) => require(['../page/financialm/fundReconReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/fundReconPlatformReport',
                name: '资金收支-平台部分',
                component: (resolve) => require(['../page/financialm/fundReconPlatformReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/capitalReport',
                name: '资金收支-网商部分',
                component: (resolve) => require(['../page/financialm/capitalReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/withdrawalLoanStatistics',
                name: '提现借款统计',
                component: (resolve) => require(['../page/financialm/withdrawalLoanStatistics'], resolve),
                meta: { keepAlive: true }
            },

            {
                path: '/financialm/discountConfirm',
                name: '折让确认',
                component: (resolve) => require(['../page/financialm/discountConfirm'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/riskControlReport',
                name: '风控报表-合同',
                component: (resolve) => require(['../page/financialm/riskControlReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/riskControlSettlePayReport',
                name: '风控报表-开票',
                component: (resolve) => require(['../page/financialm/riskControlSettlePayReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/riskControlAccountReport',
                name: '风控报表-授信',
                component: (resolve) => require(['../page/financialm/riskControlAccountReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/driverPaymentReport',
                name: '司机支付流水报表',
                component: (resolve) => require(['../page/financialm/driverPaymentReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/financialStatements',
                name: '财务报表',
                component: (resolve) => require(['../page/financialm/financialStatements'], resolve),
                meta: { keepAlive: true }
            },

            {
                path: '/financialm/bizPaymentReport',
                name: '业务支付明细统计表',
                component: (resolve) => require(['../page/financialm/bizPaymentReport'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/financialm/DirverSettlementmTwo',
                name: '司机结算网商2.0',
                component: (resolve) => require(['../page/financialm/DirverSettlementmTwo'], resolve),
                meta: { keepAlive: true, name: '/financialm/DirverSettlementmTwo' }
            },
            {
                path: '/financialm/ExcImportSettlement',
                name: 'excel导入结算',
                component: (resolve) => require(['../page/financialm/ExcImportSettlement'], resolve),
                meta: { keepAlive: true, name: '/financialm/ExcImportSettlement' }
            },

            {
                path: '/financialm/DirverSettleConfirmTwo',
                name: '司机结算2.0',
                component: (resolve) => require(['../page/financialm/DirverSettleConfirmTwo'], resolve),
            },
            {
                path: '/financialm/DriverBatchSettlement',
                name: '批量结算',
                component: (resolve) => require(['../page/financialm/DriverBatchSettlement'], resolve),
            },


        ]
    },
    {
        path: '',
        component: home,
        name: '合同授信',
        iconCls: 'el-icon-message',
        children: [{
                path: '/Contract/carrierContract',
                name: '承运合同',
                component: (resolve) => require(['../page/Contract/carrierContract'], resolve),
                meta: { keepAlive: true, name: '/Contract/carrierContract' }
            },
            {
                path: '/Contract/AddCarrierContract',
                name: '承运合同1',
                component: (resolve) => require(['../page/Contract/AddCarrierContract'], resolve),
            },
            {
                path: '/Contract/carrierContractDetail',
                name: '承运合同2',
                component: (resolve) => require(['../page/Contract/carrierContractDetail'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/Contract/subcontract',
                name: '分包合同',
                component: (resolve) => require(['../page/Contract/subcontract'], resolve),
                meta: { keepAlive: true, name: '/Contract/subcontract' }
            },
            {
                path: '/Contract/AddSubcontract',
                name: '分包合同1',
                component: (resolve) => require(['../page/Contract/AddSubcontract'], resolve),
                meta: { keepAlive: true, name: '/Contract/AddSubcontract'}// 不需要缓存
            },
            {
                path: '/Contract/subcontractDetail',
                name: '分包合同2',
                component: (resolve) => require(['../page/Contract/subcontractDetail'], resolve),
                meta: { keepAlive: true, name: '/Contract/subcontractDetail'}
            },
            {
                path: '/Contract/DriverContract',
                name: '司机合同',
                component: (resolve) => require(['../page/Contract/DriverContract'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/Contract/DriverContractDetail',
                name: '司机合同1',
                component: (resolve) => require(['../page/Contract/DriverContractDetail'], resolve),
                //meta: { keepAlive: false}// 不需要缓存
            },
            {
                path: '/Contract/creditEnquiry',
                name: '授信客户查询',
                component: (resolve) => require(['../page/Contract/creditEnquiry'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/Contract/enquiryHistory',
                name: '授信记录',
                component: (resolve) => require(['../page/Contract/enquiryHistory'], resolve),
            }, {
                path: '/Contract/applicationCredit',
                name: '授信管理',
                component: (resolve) => require(['../page/Contract/applicationCredit'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/Contract/personContract',
                name: '个人合同',
                component: (resolve) => require(['../page/Contract/personContract'], resolve),
                meta: { keepAlive: true }
            },
        ]
    },
    {
        path: '',
        component: home,
        name: '评价管理',
        iconCls: 'el-icon-message',
        children: [{
                path: '/taskRate/compRate',
                name: '企业评价',
                component: (resolve) => require(['../page/taskRate/compRate'], resolve),
            },
            {
                path: '/taskRate/driverRate',
                name: '司机评价',
                component: (resolve) => require(['../page/taskRate/driverRate'], resolve),
            },
            {
                path: '/taskRate/insuranceClaims',
                name: '保险理赔',
                component: (resolve) => require(['../page/taskRate/insuranceClaims'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/taskRate/complaintAdvice',
                name: '投诉建议',
                component: resolve => require(['../page/taskRate/complaintAdvice'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/taskRate/driverEvaluation',
                name: '司机评价中心',
                component: resolve => require(['../page/taskRate/driverEvaluation'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/taskRate/businessValuation',
                name: '企业评价中心',
                component: resolve => require(['../page/taskRate/businessValuation'], resolve),
                meta: { keepAlive: true }
            },
            {
                path: '/taskRate/driverEvaluationDetails',
                name: '司机评价中心详情',
                component: resolve => require(['../page/taskRate/driverEvaluationDetails'], resolve),
            },
            {
                path: '/taskRate/enterpriseEvaluationDetails',
                name: '企业评价中心详情',
                component: resolve => require(['../page/taskRate/enterpriseEvaluationDetails'], resolve),
            },


        ]
    },
    {
        path: '',
        component: home,
        name: '图表',
        iconCls: 'el-icon-charts',
        children: [{
            path: '/charts/echartsDashboard',
            name: '图表分析',
            component: resolve => require(['../page/charts/echartsDashboard'], resolve),
        }]
    },

    {
        path: '',
        component: home,
        name: '交委接口',
        iconCls: 'el-icon-charts',
        children: [{
                path: '/trafficCommittee/carrierInfor',
                name: '承运商信息上传',
                component: resolve => require(['../page/trafficCommittee/carrier'], resolve),
                meta: { keepAlive: true, name: '/trafficCommittee/carrierInfor' }
            },
            {
                path: '/trafficCommittee/Waybill',
                name: '运单上传',
                component: resolve => require(['../page/trafficCommittee/Waybill'], resolve),
                meta: { keepAlive: true, name: '/trafficCommittee/Waybill' }

            },
            {
                path: '/trafficCommittee/carrierInfor',
                name: '承运商信息编辑',
                component: resolve => require(['../page/trafficCommittee/carrierInfor'], resolve)
            },
            {
                path: '/trafficCommittee/WaybillDetails',
                name: '运单编辑',
                component: resolve => require(['../page/trafficCommittee/WaybillDetails'], resolve)
            },
            {
                path: '/trafficCommittee/WaybillDetailsZwl',
                name: '运单编辑',
                component: resolve => require(['../page/trafficCommittee/WaybillDetailsZwl'], resolve)
            },
            {
                path: '/trafficCommittee/WaybillVehicle',
                name: '车辆编辑',
                component: resolve => require(['../page/trafficCommittee/WaybillVehicle'], resolve)
            },
            {
                path: '/trafficCommittee/WaybillDriver',
                name: '驾驶员编辑',
                component: resolve => require(['../page/trafficCommittee/WaybillDriver'], resolve)
            },
            {
                path: '/trafficCommittee/WaybillPaySerial',
                name: '资金流水编辑',
                component: resolve => require(['../page/trafficCommittee/WaybillPaySerial'], resolve)
            },
            {
                path: '/trafficCommittee/vehicleUpload',
                name: '车辆上传',
                component: resolve => require(['../page/trafficCommittee/vehicleUpload'], resolve),
                meta: { keepAlive: true, name: 'trafficCommittee/VehicleUpload' }
            },
            {
                path: '/trafficCommittee/driverUpload',
                name: '驾驶员上传',
                component: resolve => require(['../page/trafficCommittee/driverUpload'], resolve),
                meta: { keepAlive: true, name: '/trafficCommittee/driverUpload' }
            },
            {
                path: '/trafficCommittee/WaybillZwl',
                name: '中物联运单上传',
                component: resolve => require(['../page/trafficCommittee/WaybillZwl'], resolve),
                meta: { keepAlive: true, name: '/trafficCommittee/WaybillZwl' }

            },
            {
                path: '/trafficCommittee/vehicleUploadZwl',
                name: '中物联车辆上传',
                component: resolve => require(['../page/trafficCommittee/vehicleUploadZwl'], resolve),
                meta: { keepAlive: true, name: 'trafficCommittee/vehicleUploadZwl' }
            },
            {
                path: '/trafficCommittee/driverUploadZwl',
                name: '中物联驾驶员上传',
                component: resolve => require(['../page/trafficCommittee/driverUploadZwl'], resolve),
                meta: { keepAlive: true, name: '/trafficCommittee/driverUploadZwl' }
            },
        ]
    },

    {
        path: '',
        component: home,
        name: '加油么',
        iconCls: 'el-icon-charts',
        children: [{
            path: '/refuel/abnormal',
            name: '加油么异常处理',
            component: resolve => require(['../page/refuel/abnormal'], resolve),
        }, {
            path: '/refuel/testMessage',
            name: '长连接测试',
            component: resolve => require(['../page/refuel/testMessage'], resolve),
        }]
    },
];
const router = new VueRouter({
    // base: '/dist',
    // mode: 'history',
    routes
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js